import React from 'react'

const HorizontalRule = () => {
  return <hr className="my-6 border-third w-full mx-auto" />
}

export default HorizontalRule
